import React from "react";
import "./SagwanWood.css";
import SagwanWoodLogo from "../../../assets/Sagwan Wood.png";

function SagwanWood() {
  return (
    <div className="sagwan-wood-custom-1-containers">
      <div className="sagwan-wood-custom-1-content">
        <a href="http://sagwanwood.com" target="_blank" rel="noopener noreferrer">
          <div className="sagwan-wood-custom-1-logo-container">
            <img
              src={SagwanWoodLogo}
              alt="SagwanWoodLogo"
              className="sagwan-wood-custom-1-logo"
            />
          </div>
        </a>

        <div className="sagwan-wood-custom-1-text-container">
          <h1 className="sagwan-wood-custom-1-main-title">SagwanWood.com</h1>
          <h2 className="sagwan-wood-custom-1-second-title">
            Crafting Spaces, Sculpting Elegance
          </h2>
          <p className="sagwan-wood-custom-1-descriptions">
          SagwanWood.com is more than a woodworking platform; it's a symphony
            harmonizing artistry and craftsmanship. Envision a digital atelier
            where wood transforms into functional elegance. Our platform serves
            not only as a source of wood; it's an artisanal cosmos where designs
            spring to life. Create bespoke furniture, conceive exquisite
            interiors, and shape spaces resonating with timeless grandeur.
            SagwanWood.com isn't solely a marketplace; it's a testament to the
            art of creation, where each product emerges as a masterpiece steeped
            in trust and quality.
            <br />
            <br />• A diverse array of premium-grade wood products tailored for
            furniture and construction. diverse vehicle types.
            <br></br>• Offering customizable options to design bespoke interiors
            and furnishings.
            <br></br>• Expertise in crafting an assortment of wooden products,
            including doors, windows, and floors.
            <br></br>• A user-friendly platform facilitating seamless design and
            ordering of wood-based products.
            <br></br>• Our engineers and dedicated experienced team can also
            oversee projects, transforming spaces in places such as hospitals,
            schools, colleges, commercial plazas, shopping malls, apartment
            buildings, housing societies, and universities. Our specialization
            in woodwork includes unique kitchen designs that are durable and
            timeless.
          </p>
       
        </div>
      </div>
    </div>
  );
}

export default SagwanWood;
